var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "merchant",
      attrs: {
        title: "供应商列表信息",
        visible: _vm.visible,
        width: "68%",
        "append-to-body": true,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          attrs: { model: _vm.query, inline: true, size: "small" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入供应商名称", clearable: "" },
                model: {
                  value: _vm.query.searchKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.query, "searchKey", $$v)
                  },
                  expression: "query.searchKey",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "success" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            load: _vm.loading,
            data: _vm.data,
            border: "",
            "max-height": "280px",
            size: "small",
            "tooltip-effect": "dark",
            "row-key": function (row) {
              return row.id
            },
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              align: "center",
              width: "55",
              "reserve-selection": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "供应商ID",
              width: "120",
              align: "center",
              prop: "id",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "供应商", prop: "name", align: "center" },
          }),
        ],
        1
      ),
      _vm.page.total > 0
        ? _c("pagination", {
            attrs: {
              total: _vm.page.total,
              page: _vm.page.current,
              limit: _vm.page.size,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.page, "current", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
              pagination: _vm.onLoad,
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.submit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }